import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

/** Sword-slash page transition — a fast, subtle blue streak on route change. */
export default function PageTransition() {
  const { pathname } = useLocation();
  const first = useRef(true);
  const [stamp, setStamp] = useState(0);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    setStamp(Date.now());
    const t = setTimeout(() => setStamp(0), 650);
    return () => clearTimeout(t);
  }, [pathname]);

  if (!stamp) return null;
  return <div key={stamp} className="sword-slash" aria-hidden="true" data-testid="page-transition" />;
}
